export default __webpack_public_path__ + "static/media/create-new.104f07c6.svg";